import { createSelector, Selector } from 'reselect';
import { selectLeaseDocumentRoot } from './lease-document.selectors';
import { RootReducer } from '../../store.types';

export const selectShouldReturnForReceiverReview: Selector<RootReducer, boolean> = createSelector(
  selectLeaseDocumentRoot,
  state => state.shouldReturnForReceiverReview
);
